import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Breadcrumb from "@/components/feature/Breadcrumb";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqList, siteInfo } from "@/mocks/site";

const faqJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "FAQPage",
      mainEntity: faqList.map((item) => ({
        "@type": "Question",
        name: item.question,
        acceptedAnswer: { "@type": "Answer", text: item.answer },
      })),
    },
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "首页", item: "https://fvwyz.cn/" },
        { "@type": "ListItem", position: 2, name: "常见问题", item: "https://fvwyz.cn/faq" },
      ],
    },
  ],
};

export default function Faq() {
  return (
    <SiteLayout>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }} />

      <div className="border-b border-background-200 bg-background-100">
        <div className="mx-auto w-full px-4 py-8 md:px-6 md:py-12">
          <Breadcrumb items={[{ label: "常见问题" }]} />
          <h1 className="mt-4 font-heading text-2xl font-black text-foreground-950 md:text-4xl">常见问题</h1>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            关于更新频率、内容来源、榜单算法与隐私处理，我们把浏览过程中最常被问到的问题集中整理在这里。
          </p>
        </div>
      </div>

      <div className="mx-auto grid w-full grid-cols-1 gap-8 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <FaqAccordion items={faqList} />
        </div>

        <aside className="flex flex-col gap-6">
          <div className="rounded-lg border border-background-200 bg-background-50 p-5">
            <h2 className="font-heading text-base font-bold text-foreground-950">还没解决？</h2>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              如果这里没有你想问的问题，可以直接发邮件给我们，编辑会尽快回复。
            </p>
            <a
              href={`mailto:${siteInfo.email}`}
              className="mt-4 inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-mail-send-line w-4 h-4 flex items-center justify-center"></i>
              </span>
              {siteInfo.email}
            </a>
          </div>

          <div className="rounded-lg border border-accent-200 bg-accent-50 p-5">
            <h2 className="font-heading text-base font-bold text-accent-900">快速导航</h2>
            <ul className="mt-3 space-y-2 text-sm text-accent-900/90">
              <li>
                <Link to="/rankings" className="transition-colors hover:text-accent-700">
                  → 查看实时热搜榜
                </Link>
              </li>
              <li>
                <Link to="/articles" className="transition-colors hover:text-accent-700">
                  → 浏览全部吃瓜资讯
                </Link>
              </li>
              <li>
                <Link to="/about" className="transition-colors hover:text-accent-700">
                  → 了解我们的内容原则
                </Link>
              </li>
            </ul>
          </div>
        </aside>
      </div>
    </SiteLayout>
  );
}